<template lang="pug">
  dv-manageable-combo-dialog(
    :method-create="methodCreate"
    :method-update="methodUpdate"
    :entity-name-upsert="entityNameUpsert"
    :form-schema="formSchema"
    @form:success="updateItems"
    v-slot="{ openForm }"
  )
    component(
      v-if="currentTypeData.component"
      ref="serverAutocomplete"
      v-bind="extraAttrs"
      v-on="$listeners"
      :method="methodList"
      :is="currentTypeData.component"
      :value="value"
    )
      template(v-slot:item="{ on, attrs, item }")
        dv-manageable-combo-item(
          v-bind="attrs"
          v-on="on"
          :item="item"
          :item-text="itemText"
          :item-value="itemValue"
          @edit="openForm"
        )

      template(v-slot:append-item)
        v-list.pb-0(
          style="position: sticky; bottom: -4px;"
        )
          v-list-item.ui-primary--text(
            @click="() => openForm()"
          )
            v-list-item-icon
              v-icon $ui-plus
            v-list-item-title
              span Создать {{ entityName.toLowerCase() }}
</template>

<script>
import DvAutocompleteServer from '../DvAutocompleteServer.vue';
import DvManageableComboDialog from './DvManageableComboDialog.vue';
import DvManageableComboItem from './DvManageableComboItem.vue';

const TYPES = {
  autocomplete: 'autocomplete',
};

const TYPES_DATA = {
  [TYPES.autocomplete]: {
    id: TYPES.autocomplete,
    component: DvAutocompleteServer,
  },
};

export default {
  components: {
    DvManageableComboItem,
    DvManageableComboDialog,
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    methodCreate: {
      type: Function,
      required: true,
    },
    methodUpdate: {
      type: Function,
      required: true,
    },
    methodDelete: {
      type: Function,
      default: undefined,
    },
    methodList: {
      type: Function,
      required: true,
    },
    formSchema: {
      type: Array,
      default: () => ([]),
    },
    type: {
      type: String,
      default: TYPES.autocomplete,
    },
    entityName: {
      type: String,
      required: true,
    },
    entityNamePlural: {
      type: String,
      required: true,
    },
    entityNameUpsert: {
      type: String,
      required: true,
    },
    itemText: {
      type: String,
      default: 'name',
    },
    itemValue: {
      type: String,
      default: 'id',
    },
    value: {
      type: [Number, String, Object],
      default: undefined,
    },
  },
  computed: {
    currentTypeData() {
      const { type } = this;
      return TYPES_DATA[type];
    },
    extraAttrs() {
      const { $attrs, entityName, entityNamePlural } = this;
      const { multiple } = $attrs;

      return {
        placeholder: `Выберите ${multiple ? entityNamePlural.toLowerCase() : entityName.toLowerCase()}`,
        ...$attrs,
      };
    },
  },
  methods: {
    updateItems(item) {
      this.$refs?.serverAutocomplete?.updateItems?.([item]);
    },
  },
};
</script>
